import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.staging.seek.com',
    clientDomain: 'nz.employer.staging.seek.com',
    clientId: 'h1luQjtA9e7frpFYYWIUyDp719n544Aj',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://talent.seek.co.nz/contactus/',
    },
    siteName: siteNames.employer.seek.nz,
    zone: getZoneFromSite(siteNames.employer.seek.nz),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=nz_employer_staging_seek_com.js.map